import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import Glossary from '../../images/Glossary (3).png'
function EmissionsManagement() {

   const carbonData = [
{
      title: "Baseline emissions:",
      description: "The reference level of greenhouse gas emissions used as a benchmark against which emission reductions or increases are measured. It represents the anticipated emissions in the absence of any mitigation efforts or projects."
    },
    {
      title: "Project emissions:",
      description: "The total amount of greenhouse gas emissions associated with a specific project or activity. Project emissions are compared to the baseline emissions to determine the effectiveness of emission reduction initiatives."
    },
    {
      title: "Emission avoidance:",
      description: "The strategy or set of actions implemented to prevent or reduce the release of greenhouse gas emissions into the atmosphere. Emission avoidance measures aim to minimize the environmental impact associated with specific activities or processes."
    },
    {
      title: "Emission reductions:",
      description: "The quantifiable and verified decrease in greenhouse gas emissions achieved through the implementation of specific actions or projects. Emission reductions are typically measured against a predefined baseline."
    },
    {
      title: "Emission sources:",
      description: "Points or processes that release greenhouse gases into the atmosphere. Emission sources include industrial facilities, power plants, transportation, agriculture, and other activities contributing to climate-altering gases."
    },
    {
      title: "Fugitive emissions:",
      description: "Unintentional or accidental releases of greenhouse gases during the production, processing, transportation, or use of fossil fuels or other industrial processes."
    },
    {
      title: "Direct emissions:",
      description: "Greenhouse gas emissions released directly from a specific source, such as exhaust from industrial processes, combustion of fossil fuels, or emissions from manufacturing facilities."
    },
    {
      title: "Indirect emissions:",
      description: "Greenhouse gas emissions that result from activities or processes but occur at a different location, such as emissions from the generation of purchased electricity or transportation services."
    },
    {
      title: "Stationary combustion:",
      description: "The burning of fuels in fixed or stationary sources, such as power plants, industrial facilities, or residential heating systems."
    },
    {
      title: "Mobile combustion:",
      description: "The combustion of fuels in mobile sources, including vehicles, ships, aircraft, and other forms of transportation."
    },
    {
      title: "GHG emissions:",
      description: "Greenhouse Gas Emission. The release of gases, such as carbon dioxide, methane, and nitrous oxide, into the atmosphere that contribute to the greenhouse effect and global warming."
    },
    {
      title: "Fossil -fuel based power generation:",
      description: "The process of generating electricity using fossil fuels such as coal, oil, or natural gas. This method involves burning these fuels to produce steam, which turns turbines to generate electrical power."
    }
  ];


  const CarbonItem = ({ title, description }) => {
  return (
    <div className="flex flex-col items-start p-0 gap-4 w-full max-w-[1152px]">
      <h3 className="text-[24px] font-medium text-2xl leading-[29px] text-[#141414]">
        {title}
      </h3>
      <p className="w-full  font-normal text-[16px] leading-[150%] text-[#141414]">
        {description}
      </p>
    </div>
  );
};
  return (
    <>
    <Header/>
    <div className="relative w-full max-w-[1440px] h-[933px] top-[0px] mx-auto">
      {/* Text Section */}
      <div className="absolute w-full max-w-[1200px] h-[76px] left-1/2 transform -translate-x-1/2 top-[82px] flex flex-col items-center p-0 gap-10">
        <h1 className="w-full max-w-[688px] h-[76px] font-medium text-6xl leading-[76px] text-center text-[#141414]">
         Emissions Management 
        </h1>
      </div>

      {/* Image Section */}
      <img 
        className="absolute w-full max-w-[1200px] h-[552px] left-1/2 transform -translate-x-1/2 top-[275px] rounded-2xl  object-fill"
        src={Glossary}
        alt="Carbon Incentive"
      />
    </div>


 <div className="w-full max-w-[1200px] mx-auto mt-20 mb-20 flex flex-col items-start gap-8">
      <h2 className=" font-bold text-[32px] leading-[38px] text-[#0D924F]">
          Emissions Management
      </h2>
      <div className="flex flex-col gap-6 w-full">
        {carbonData.map((item, index) => (
          <CarbonItem 
            key={index}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
    <Footer/>
    </>



  )
}

export default EmissionsManagement





